import React from 'react'
import ErrorBoundary from '../components/ErrorBoundary'
import ContactForm from '../components/ContactForm'
import StaticPage from '../components/StaticPage'

function ContactPage() {
  return (
    <ErrorBoundary>
      <StaticPage
        title="Contact Us"
        intro="Get in touch with the Wingbeat Paragliding Club"
      >
        <p>
          Questions about flying in the Borders, our sites, or the club? Send us a message below
          and one of the team will get back to you. If you're interested in joining, use the{' '}
          <a href="/membership">join the club</a> form instead.
        </p>
        <p className="muted">
          Planning to fly a Wingbeat site as a visitor? Please check current site status and, where
          noted, contact the club or the landowner before flying.
        </p>
        <ContactForm kind="contact" />
      </StaticPage>
    </ErrorBoundary>
  )
}

export default ContactPage
